var exports = {
  "k": "x9245d464--ca62f6--container",
};

module.exports = exports;
